import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  sync() {
    this.element.contentDocument.location.reload();
  }

  siteId() {
    return this.element.contentDocument.querySelector("body").dataset.siteId;
  }
}
